module.exports = __webpack_public_path__ + "static/img/办结总金额@4x.f6d19b75.png";